import { render, staticRenderFns } from "./185.vue?vue&type=template&id=ecd9a326&scoped=true&"
var script = {}
import style0 from "./185.vue?vue&type=style&index=0&id=ecd9a326&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd9a326",
  null
  
)

export default component.exports